<i18n src="@/i18n/components/AdvancedFilter.json"></i18n>
<template>
	<div class="pb-4" :class="overflowMaxFilters ? 'bg-white/60 border-b-gray-300 mb-2 p-4 rounded shadow' : 'border-transparent'">
		<div class="flex items-center">
			<!-- Filter !-->
			<button type="button" class="group px-2.5 py-1.5" @click="handleClearFilters">
				<i class="fal text-lg" :class="hasFilter ? 'fa-filter-slash text-red-600' : 'fa-filter text-gray-600'"></i>
			</button>
			<div class="ml-2 flex">
				<div class="flex" :class="overflowMaxFilters ? 'flex-col space-y-3' : 'space-x-3'">
					<template v-for="(filter, filterIndex) in filters">
						<AdvancedFilterItem :fields="options" :filter="filter"
											@update:filter="handleSetFilter($event, filter, filterIndex)" @apply="$emit('apply', filters)"
											@remove="handleRemoveFilter(filter, filterIndex)"/>
					</template>
				</div>
				<template v-if="!hasFilter">
					<!-- Add !-->
					<button type="button" class="rounded border border-dashed border-gray-400 flex space-x-2 px-2.5 py-1.5 text-gray-600 hover:bg-gray-100 hover:text-gray-800 group items-center"
							@click="handleAddFilter">
						<i class="fa fa-plus-circle text-gray-400 group-hover:text-green-500"></i>
						<span class="text-gray-500 hover:text-gray-800">{{ $t('advanced_filter.buttons.add_filter') }}</span>
					</button>
				</template>
			</div>
			<!-- !-->
			<div class="mt-0.5 ml-1 flex space-x-2">
				<template v-if="hasFilter">
					<!-- Add !-->
					<button type="button" class="group px-2.5 py-1.5" @click="handleAddFilter">
						<i class="fa fa-plus text-green-800/30 group-hover:text-green-500"></i>
						<!--						{{ $t('advanced_filter.buttons.add') }}-->
					</button>
				</template>
			</div>
			<!-- Textual Filter !-->
			<div v-if="textFilter" class="w-full mt-3 flex sm:mt-0 sm:ml-auto mb-0 sm:flex-shrink-0 max-w-[140px] xl:max-w-[240px] 2xl:max-w-[340px]">
				<!-- Search !-->
				<label class="w-full rounded-md shadow-sm flex relative">
					<FormInput v-model="search" @enter="handleAddTextFilter" class="w-full"/>
					<button @click="handleAddTextFilter" class="mx-3 top-0 right-0 absolute rounded focus:outline-none focus:ring-offset-2 focus:ring-2 focus:ring-turquoise z-10"
							style="margin-top: 9px">
						<i class="fal fa-search text-gray-500"></i>
					</button>
				</label>
				<!-- AI Assistant !-->
				<div v-if="showAISearch" class="relative flex items-center">
					<button class="ml-3 rounded focus:outline-none focus:ring-offset-2 focus:ring-2 focus:ring-turquoise z-10" @click="handleAI">
						<i class="fa fa-user-robot text-gray-400 "></i>
					</button>
					<Loading v-if="isLoadingAi" use-spinner spinner-color="text-turquoise"/>
				</div>
				<!-- / AI Assistant !-->
			</div>
			<!-- / Textual Filter !-->
		</div>
		<slot/>
	</div>
</template>

<script>
import AdvancedFilterItem from "./AdvancedFilter/AdvancedFilterItem.vue"
import FormInput from "./FormInput.vue"
import Loading from "./Loading.vue"

export default {
	name: "AdvancedFilter",
	model: {
		prop: 'filters',
		event: 'update:filters'
	},
	props: {
		filters: Array,
		textFilter: {
			type: Boolean,
			default: true
		}
	},
	components: {
		AdvancedFilterItem,
		FormInput,
		Loading
	},
	provide() {
		return {
			advancedFilterState: {
				options: this.options,
				filters: this.filters
			}
		}
	},
	data() {
		return {
			isLoadingAi: false,
			options: [],
			// filters: [],
			search: null,
			showAISearch: false
		}
	},
	computed: {
		hasFilter() {
			return this.filters?.length > 0
		},
		overflowMaxFilters() {
			return this.filters?.length >= 3
		}
	},
	methods: {
		/**
		 * Handle add filter
		 */
		handleAddFilter() {
			this.$emit('update:filters', [...this.filters, {
				field: null,
				operator: "",
				value: ""
			}])
		},
		/**
		 * Handle add text filter
		 */
		handleAddTextFilter() {
			if (!this.search) {
				this.$emit("apply", this.filters)
				return
			}

			const filters = copy_obj(this.filters).filter(item => item.field?.field !== "$search")

			this.$emit('update:filters', [...filters, {
				field: {
					field: "$search"
				},
				operator: null,
				value: this.search
			}])

			this.search = null

			this.$emit("apply", filters)
		},
		/**
		 * Handle set filter
		 * @param evt
		 * @param filter
		 * @param filterIndex
		 */
		handleSetFilter(evt, filter, filterIndex) {
			this.$set(this.filters, filterIndex, evt)
		},
		handleApply(evt, filter, filterIndex) {
			this.$set(this.filters, filterIndex, evt)
			this.$emit('apply', this.filters)
		},
		/**
		 * Handle remove filter
		 * @param filter
		 * @param filterIndex
		 */
		handleRemoveFilter(filter, filterIndex) {
			this.filters.splice(filterIndex, 1)
			if (filter.value) this.$emit('apply', this.filters)
		},
		/**
		 * Handle clear filters
		 */
		handleClearFilters() {
			const filters = this.filters.filter(item => item.required === true)
			this.$emit('update:filters', filters)
			this.$emit('apply', filters)
		},
		/**
		 * Handle ai
		 */
		handleAI() {
			this.isLoadingAi = true
		}
	}

}
</script>